import { createAsyncThunk } from "@reduxjs/toolkit";
import { useCustomAxios } from "../../shared/lib/customAxios";
import { API_ENDPOINTS } from "../../shared/constants/constants";

export const downloadReportingExcel = createAsyncThunk(
  "buyer/downloadReportingExcel",
  async (data: any) => {
    const { axiosPost } = useCustomAxios();
    const { url, reqBody } = data;
    try {
      const response = await axiosPost(url, reqBody);

      const downloadLink = document.createElement("a");
      downloadLink.href = response.data.downloadUrl;
      downloadLink.download = "reporting.xlsx";
      downloadLink.target = "_blank";
      downloadLink.click();

      return { data: response.data, status: response.status };
    } catch (error: any) {
      console.log(error);
      return error.response.data;
    }
  }
);

export const getReport = createAsyncThunk(
  "report/getReport",
  async (reqBody: any, { rejectWithValue }) => {
    const { axiosPost } = useCustomAxios();
    const url = `${API_ENDPOINTS.getReport}`;
    try {
      const response = await axiosPost(url, reqBody);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return rejectWithValue(error.response.data.message);
    }
  }
);

export const getCategoryWiseRequestItemsReport = createAsyncThunk(
  "categoryWiseRequestItemsReport",
  async (parameter: any, { rejectWithValue }) => {
    const { axiosGet } = useCustomAxios();
    let url = `${API_ENDPOINTS.categoryWiseRequestItemsReport}`;
    Object.entries(parameter).forEach(
    ([key, value], index) =>
      (url = url + `${index > 0 ? "&" : "?"}${key}=${value}`)
  );
    try {
      const response = await axiosGet(url);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
); 

export const getclientWiseMonthlyOrderReport = createAsyncThunk(
  "getclientWiseMonthlyOrderReport",
  async (parameter: any, { rejectWithValue }) => {
    const { axiosGet } = useCustomAxios();
    let url = `${API_ENDPOINTS.getclientWiseMonthlyOrderReport}`;
    Object.entries(parameter).forEach(
    ([key, value], index) =>
      (url = url + `${index > 0 ? "&" : "?"}${key}=${value}`)
  );
    try {
      const response = await axiosGet(url);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
); 

export const getclientWiseMonthlyInvoiceReport = createAsyncThunk(
  "getclientWiseMonthlyInvoiceReport",
  async (parameter: any, { rejectWithValue }) => {
    const { axiosGet } = useCustomAxios();
    let url = `${API_ENDPOINTS.getclientWiseMonthlyInvoiceReport}`;
    Object.entries(parameter).forEach(
    ([key, value], index) =>
      (url = url + `${index > 0 ? "&" : "?"}${key}=${value}`)
  );
    try {
      const response = await axiosGet(url);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getInventoryReport = createAsyncThunk(
  "getInventoryReport",
  async (parameter: any, { rejectWithValue }) => {
    const { axiosGet } = useCustomAxios();
    let url = `${API_ENDPOINTS.getInventoryReport}`;
    Object.entries(parameter).forEach(
    ([key, value], index) =>
      (url = url + `${index > 0 ? "&" : "?"}${key}=${value}`)
  );
    try {
      const response = await axiosGet(url);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
);